import {
    Directive,
    ElementRef,
    Input,
    HostListener,
    EventEmitter,
    Output,
    Optional
} from "@angular/core";
import { HttpResponse, HttpClient } from "@angular/common/http";
// import { saveAs } from 'file-saver';

declare var saveAs:any;

/**
 * æä»¶ä¸è½½
 *
 * ```html
 * <button nz-button down-file http-url="assets/demo{{i}}" file-name="demoä¸­æ">{{i}}</button>
 * ```
 */
// tslint:disable-next-line:directive-selector
@Directive({ selector: "[down-file]" })
export class DownFileDirective {
    /** URLè¯·æ±åæ° */
    // tslint:disable-next-line:no-input-rename
    @Input("http-data")
    httpData: any;
    /** è¯·æ±ç±»å */
    // tslint:disable-next-line:no-input-rename
    @Input("http-method")
    httpMethod = "get";
    /** ä¸è½½å°å */
    // tslint:disable-next-line:no-input-rename
    @Input("http-url")
    httpUrl: string;
    /** æå®æä»¶åï¼è¥ä¸ºç©ºä»æå¡ç«¯è¿åç `header` ä¸­è·å `filename`ã`x-filename` */
    // tslint:disable-next-line:no-input-rename
    @Input("file-name")
    fileName: string;
    /** æååè° */
    @Output()
    success: EventEmitter<any> = new EventEmitter<any>();
    /** éè¯¯åè° */
    @Output()
    error: EventEmitter<any> = new EventEmitter<any>();

    private getDisposition(data: string) {
        const arr: any = (data || "")
            .split(";")
            .filter(i => i.includes("="))
            .map(v => {
                const strArr = v.split("=");
                const utfId = `UTF-8''`;
                let value = strArr[1];
                if (value.startsWith(utfId)) {
                    value = value.substr(utfId.length);
                }
                return { [strArr[0].trim()]: value };
            });
        return arr.reduce((o, item: any) => item, {});
    }

    constructor(private el: ElementRef, private http: HttpClient) {}

    @HostListener("click")
    _click() {
        this.el.nativeElement.disabled = true;
        this.http
            .request(this.httpMethod, this.httpUrl, {
                params: this.httpData || {},
                responseType: "blob",
                observe: "response"
            })
            .subscribe(
                (res: HttpResponse<Blob>) => {
                    if (res.status !== 200 || res.body.size <= 0) {
                        this.error.emit(res);
                        return;
                    }
                    const disposition: any = this.getDisposition(
                        res.headers.get("content-disposition")
                    );
                    const fileName =
                        this.fileName ||
                        disposition[`filename*`] ||
                        disposition[`filename`] ||
                        res.headers.get("filename") ||
                        res.headers.get("x-filename");
                    saveAs(res.body, decodeURI(fileName));
                    this.success.emit(res);
                    this.el.nativeElement.disabled = false;
                },
                err => {
                    this.error.emit(err);
                    this.el.nativeElement.disabled = false;
                }
            );
    }
}
